import { render, staticRenderFns } from "./ProtocolGrid.vue?vue&type=template&id=065854de"
import script from "./ProtocolGrid.vue?vue&type=script&lang=js"
export * from "./ProtocolGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports